import { useCallback, useState } from 'react';

import { deleteFileFromBrowserStorage, VideoRecordingEvent } from '@bonusly/common-action-input';
import { useDisclosure } from '@bonusly/design-system';
import { useEventListener } from '@bonusly/events';

import { useGlobalMediaStore } from '../../../../modules/bonus-feed/hooks/use-global-media-store';
import { GiveBoxEvent, GiveBoxOpenEventData } from '../events';
import { createRecognitionContent } from '../utils/content';

type GiveModalProps = {
	onSuccess?: () => void;
};

export const useGiveModal = ({ onSuccess }: GiveModalProps) => {
	const state = useDisclosure();

	// This isn't the ideal to do this, but is the easiest to programmatically set
	// the default content when a users triggers an event to give to a specific user.
	// The give box instance is not immediately available when the event is triggered.
	// This is a temporary solution until we can refactor the give box respond to events
	// in a more flexible way.
	const [content, setContent] = useState<any>(undefined);
	const { getActiveElement, pauseVideo } = useGlobalMediaStore();

	const initGiveToUser = useCallback(
		(data?: GiveBoxOpenEventData) => {
			if (data && data.recipient && data.text) {
				const content = createRecognitionContent(data.recipient, data.text, data.amount, data.hashtags);
				setContent(content);
			} else if (data && data.recipient) {
				const content = createRecognitionContent(data.recipient, undefined, data.amount, data.hashtags);
				setContent(content);
			} else if (data && data.text) {
				setContent({
					type: 'doc',
					content: [
						{
							type: 'paragraph',
							content: [{ type: 'text', text: data.text }],
						},
					],
				});
			}
			state.onOpen();

			// pause any video elements in the viewport
			const activeVideoElement = getActiveElement();
			if (activeVideoElement) {
				pauseVideo(activeVideoElement);
			}
		},
		[state, getActiveElement, pauseVideo]
	);

	const handleClose = () => {
		setContent(undefined);
		state.onClose();
	};

	useEventListener(GiveBoxEvent.Open, initGiveToUser);
	useEventListener(VideoRecordingEvent.ClosedCarouselModalWithNoVideo, handleClose);

	const handleOnSuccess = () => {
		handleClose();
		onSuccess?.();
		deleteFileFromBrowserStorage();
	};
	return {
		content,
		onOpen: state.onOpen,
		onClose: handleClose,
		onSuccess: handleOnSuccess,
		isOpen: state.isOpen,
	};
};
